import { render, staticRenderFns } from "./DocumentStatusLabel.vue?vue&type=template&id=24270fd6&"
import script from "./DocumentStatusLabel.vue?vue&type=script&lang=js&"
export * from "./DocumentStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports